import {
    Component,
    EventEmitter,
    OnInit,
    Output,
    Input,
    ElementRef,
    ChangeDetectionStrategy,
    SimpleChange,
    OnChanges,
    ViewChildren,
    QueryList,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SuggestionFilter } from '../se-smart-text-editor/suggestion-datasource/suggestion-filter';
import { Suggestion, ExtendedSuggestion } from '../se-smart-text-editor/suggestion-datasource/suggestion';

import { TranslateService } from '@ngx-translate/core';
import { MenuEnum } from '../se-text-editor/menu/menu-items.enum';

import { defaultShortcutList } from '../se-smart-text-editor/shortcuts';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatExpansionPanel } from '@angular/material/expansion';

@Component({
    selector: 'se-ui-default-text',
    templateUrl: './se-ui-default-text.component.html',
    styleUrls: ['./se-ui-default-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SeUiDefaultTextComponent implements OnInit, OnChanges {

    @ViewChildren("expansionPanel") expPanels: QueryList<MatExpansionPanel>;

    @Input() suggestions: Suggestion[] = [];
    @Input() currentFilter: SuggestionFilter;
    @Input() defaultTextName: string = '';
    @Input() _addingNewText: boolean = false;

    @Output() selectedSuggestion = new EventEmitter<ExtendedSuggestion>();
    @Output() preSelectedSuggestionEmitter = new EventEmitter<Suggestion>();
    @Output() closeCommand = new EventEmitter<boolean>();
    @Output() undoCommand = new EventEmitter<boolean>();
    @Output() isEditing = new EventEmitter<boolean>();
    preSelectedSuggestion: Suggestion;


    private suggestionText: string = '';
    private suggestionCode: string = '';
    //_addingNewText = false;
    _originalSuggestion: Suggestion = new Suggestion();
    _selectedSuggestion: Suggestion = new Suggestion();
    _showEditOrDeleteButton = false;
    _currentSelection: Suggestion;
    _editingView = false;
    typeTexts: Array<string>;

    // vedi anche TEXT_EDITOR_TOOLBAR_FULL
    _predefinedMenuConfiguration = new Map([
        [MenuEnum.SUGGESTIONS, { visible: true }],
        [MenuEnum.NEW, { visible: false }],
        [MenuEnum.UNDO, { visible: true }],
        [MenuEnum.REDO, { visible: true }],
        [MenuEnum.TEXT_ALIGNMENT, { visible: false }],
        [MenuEnum.TEXT_FONT_WEIGHT, { visible: true }],
        [MenuEnum.TEXT_FONT_STYLE, { visible: true }],
        [MenuEnum.TEXT_DECORATION, { visible: true }],
        [MenuEnum.TEXT_FONT_FAMILY, { visible: true }],
        [MenuEnum.TEXT_FONT_SIZE, { visible: true }],
        [MenuEnum.UNORDERED_LIST, { visible: true }],
        [MenuEnum.ORDERED_LIST, { visible: true }],
        [MenuEnum.MICROPHONE, { visible: false }],
    ]);

    _shortcutList = defaultShortcutList;

    _suggestionPolicyToggleChecked = true;

    isSingleClick: Boolean = false;

    constructor(private sanitizer: DomSanitizer,
        private elementRef: ElementRef,
        private translate: TranslateService) { }

    ngOnInit() {
        if (this.suggestions && this.suggestions.length > 0) {
            this.preSelectedSuggestion = this.suggestions[0];
            this.preSelectedSuggestionEmitter.emit(this.preSelectedSuggestion);
            this.typeTexts = this.retrieveTypeTexts();
        }
    }

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        for (const propName of Object.keys(changes)) {
            if (propName === 'suggestions') {
                this.preSelectedSuggestion = this.suggestions[0];
                this.preSelectedSuggestionEmitter.emit(this.preSelectedSuggestion);
            }
        }

        if (this._addingNewText) {
            this._onAddClick();
        }
    }

    preSelectNext() {
        if (this.suggestions.length > 1 && this.preSelectedSuggestion) {
            const newPreSelectedIndex = (this.suggestions.indexOf(this.preSelectedSuggestion) + 1) % this.suggestions.length;
            this.preSelectedSuggestion = this.suggestions[newPreSelectedIndex];
            this.preSelectedSuggestionEmitter.emit(this.preSelectedSuggestion);
            this.elementRef.nativeElement.querySelector('#suggestion-div-' + newPreSelectedIndex).scrollIntoView();
        }
    }

    preSelectPrevious() {
        if (this.suggestions.length > 1 && this.preSelectedSuggestion) {
            let newPreSelectedIndex = this.suggestions.indexOf(this.preSelectedSuggestion) - 1;
            newPreSelectedIndex = newPreSelectedIndex >= 0 ? newPreSelectedIndex : this.suggestions.length - 1;
            this.preSelectedSuggestion = this.suggestions[newPreSelectedIndex];
            this.preSelectedSuggestionEmitter.emit(this.preSelectedSuggestion);
            this.elementRef.nativeElement.querySelector('#suggestion-div-' + newPreSelectedIndex).scrollIntoView();
        }
    }

    getPreselectedSuggestion(): Suggestion {
        return this.preSelectedSuggestion;
    }

    onSelect(suggestion: Suggestion) {
        /* l'invio dell'evento è ritardato per evitare che eventuali doppi click dell'utente siano propagati al background*/
        if (!this._addingNewText) {
            setTimeout(() => {
                this.selectedSuggestion.emit({ suggestion: suggestion, policy: this._suggestionPolicyToggleChecked });
            }, 150);
        }
    }


    expPanelToggle(event, i, suggestion) {
        event.stopPropagation();
        this.isSingleClick = !this.isSingleClick;
        setTimeout(() => {
            if (this.isSingleClick) {
                this.isSingleClick = false;
                this.expPanels.get(i).toggle();
            }
        }, 250);
    }

    selPanelDoubleClikc(suggestion, event) {
        this.isSingleClick = false;
        this.onSelectExpander(suggestion, event);
    }

    onSelectExpander(suggestion: Suggestion, event: any) {
        event.stopPropagation();
        if (!this._addingNewText) {
            this.onSelect(suggestion);
        }
    }

    onClose() {
        this.closeCommand.emit(true);
    }

    filterCodeAndText(suggestion: Suggestion) {
        const currentFilter: SuggestionFilter = this.currentFilter;
        this.suggestionText = suggestion.Description ? suggestion.Description : '';
        this.suggestionCode = suggestion.code ? suggestion.code : '';
        const currentFilterTextLower = (currentFilter && currentFilter.text) ? currentFilter.text.toLowerCase() : '';
        const currentFilterText = (currentFilter && currentFilter.text) ? currentFilter.text : '';


        if (this.suggestionText.toLowerCase().startsWith(currentFilterTextLower)) {
            this.suggestionText = '<span style=\'color: #e78914;\'>' + this.suggestionText.substring(0, currentFilterText.length) + '</span>' +
                this.suggestionText.substring(currentFilterText.length, this.suggestionText.length);
        }

        if (typeof suggestion.code !== 'undefined' && suggestion.code) {
            this.suggestionCode = suggestion.code;
            if (this.suggestionCode.toLowerCase().startsWith(currentFilterTextLower)) {
                this.suggestionCode = '<span style=\'color: #e78914;\'>' + this.suggestionCode.substring(0, currentFilterText.length) + '</span>'
                    + this.suggestionCode.substring(currentFilterText.length, this.suggestionText.length);
            }
            this.suggestionCode = '[' + this.suggestionCode + ']';
        }
    }

    /* part of the suggestion is highlighted if match with the current filter */
    // createSuggestionHTML(suggestion: Suggestion, index: number) {
    //   this.filterCodeAndText(suggestion);
    //   return this.sanitizer.bypassSecurityTrustHtml(index + '. ' + this.suggestionCode + ' ' + this.suggestionText);
    // }


    createSuggestionHTMLExpanderView(suggestion: Suggestion, index: number) {
        this.filterCodeAndText(suggestion);
        return this.sanitizer.bypassSecurityTrustHtml(index + '. ' + this.suggestionCode + ' ' + this.suggestionText);
    }

    _onEditClick() {
        this._showEditOrDeleteButton = false;
        this._originalSuggestion = { ...this._currentSelection };
        this._selectedSuggestion = this._currentSelection;

        this._editingView = true;
        this.isEditing.emit(true);
    }

    _onDeleteClick() {
        this.suggestions.forEach((suggestion: Suggestion, index: number) => {
            if (suggestion.id == this._currentSelection.id) this.suggestions.splice(index, 1);
        });

        this._addingNewText = false;
        this.onClose();
    }

    _onAddClick() {
        //this._addingNewText = true;
        this._showEditOrDeleteButton = false;
        this._selectedSuggestion.code = null;
        this._selectedSuggestion.Description = null;
        this.initSelectedSuggestionTexts();
    }

    private initSelectedSuggestionTexts() {
        this.typeTexts.forEach(text => this._selectedSuggestion.Sentence[text] = null);
    }

    private retrieveTypeTexts(): Array<string> {
        if (!this.suggestions || this.suggestions.length === 0) {
            return undefined;
        }
        return Object.getOwnPropertyNames(this.suggestions[0]);
    }

    _undoFunction() {
        this._addingNewText = false;
        this._currentSelection.code = this._originalSuggestion.code;
        this._currentSelection.Description = this._originalSuggestion.Description;
        this._currentSelection.Sentence = this._originalSuggestion.Sentence;

        this._editingView = false;
        this.isEditing.emit(false);
        this._showEditOrDeleteButton = false;
        this.undoCommand.emit(true);
    }

    _okFunction() {
        if (this._addingNewText) {
            this._addingNewText = false;
            this.removeLabeFromSentences();
            this._selectedSuggestion.id = this.suggestions[this.suggestions.length - 1].id + 1;
            this._selectedSuggestion.IsNormality = false;
            this._selectedSuggestion.newLineAfter = false;
            this.suggestions.push(this._selectedSuggestion);
            // DGS qui ci serve chiamare servizio REST per salvare la nuova suggestion
        }
        this._editingView = false;
        this.isEditing.emit(false);
        // Non chiudo la modale per dare la possibilita' di selezionare il nuovo testo?
        // this.onClose();
    }

    // DGS questo è da togliere non possiamo giocare con lo split mettiamoci una label vera o un placeholder
    private removeLabeFromSentences() {
        const typeTexts = this.retrieveTypeTexts();
        typeTexts.forEach(
            field =>
                this._selectedSuggestion.Sentence[field] = this._selectedSuggestion.Sentence[field].split('Inserire la sentence: ')[1] // DGS come mai non abbiamo il placeholder?
        );
    }

    _isOkButtonDisabled() {
        if (this._editingView) {
            return (!this._selectedSuggestion.Description || this._selectedSuggestion.Description.length <= 0) // DGS come fa una stringa ad avere lunghezza sotto 0?
                // DGS TODO da aggiustre || (!this._selectedSuggestion.Sentence || this._selectedSuggestion.Sentence.length <= 0)
                || this.noTextsSentecePresent()
                || (!this._selectedSuggestion.code || this._selectedSuggestion.code.length <= 0);
        }
        return (!this._selectedSuggestion.Description || this._selectedSuggestion.Description.split('Inserire la description: ')[1].length <= 0)
            // DGS TODO da aggiustre || (!this._selectedSuggestion.Sentence || this._selectedSuggestion.Sentence.split('Inserire la sentence: ')[1].length <= 0)
            || this.noSplitTextsSentecePresent()
            || (!this._selectedSuggestion.code || this._selectedSuggestion.code.split('. Inserire il code: ')[1].length <= 0);
    }

    private noTextsSentecePresent(): boolean {
        const typeTexts = this.retrieveTypeTexts();
        let result: boolean = false;
        typeTexts.forEach(
            text =>
                result || (!this._selectedSuggestion.Sentence[text] || this._selectedSuggestion.Sentence[text].split('Inserire la sentence: ')[1].length <= 0)
        );
        return result;
    }

    private noSplitTextsSentecePresent(): boolean {
        const typeTexts = this.retrieveTypeTexts();
        let result: boolean = false;
        typeTexts.forEach(
            text =>
                result || (!this._selectedSuggestion.Sentence[text] || this._selectedSuggestion.Sentence[text].length <= 0)
        );
        return result;
    }

    _openedAccordion(selectedSuggestion: Suggestion, index: number) {
        this._currentSelection = selectedSuggestion;

        //setTimeout(() => {
        this._showEditOrDeleteButton = true;
        //}, 0);

        // scroll to selected suggestion
        let id = 'suggestion-div-' + index;
        let el = document.getElementById(id);
        if (el) {
            el.scrollIntoView();
        }
    }

    _closedAccordion() {
        this._showEditOrDeleteButton = false;
    }

    public _onSuggestionPolicyChange($event: MatSlideToggleChange) {
        this._suggestionPolicyToggleChecked = $event.checked;
    }

}
